export default __webpack_public_path__ + "static/media/Icon-C.9080ab8d.svg";